module.exports = __webpack_public_path__ + "img/fake-user-4.c19cb7c3.png";